const en = {
    "dbm.stage.nav.home": "Home",
    "dbm.stage.nav.settlement": "Settlement",
    "dbm.stage.nav.spot": "Spot",
    "dbm.stage.nav.forward": "Forward",
    "dbm.stage.search": "Search",
    "dbm.stage.search.add.to.spot": "Spot+",
    "dbm.stage.search.no.result": "Your search yields no results.",
    "dbm.button.menu": "Menu",
    "dbm.button.options": "Options",
    "dbm.button.options.toggle": "ToggleOptions",
    "dbm.button.close": "Close",
    "dbm.button.valueDateCalendar": "Value date calendar",
    "dbm.export.pdf": "PDF",
    "dbm.export.csv": "CSV",
    "dbm.export.xlsx": "Excel",
    "dbm.export.exportAsLabel": "Save {tableName} as",
    "dbm.export.yearlyAverageRates": "Yearly average rates",
    "dbm.export.monthlyOverview": "Monthly overview",
    "dbm.export.monthlyUltimo": "Monthly average rates",	
    "dbm.export.selectYear": "Select year for export",
    "dbm.export.selectMonth": "Select month for export",
    "dbm.export.EndofMonthRates": "End of month rates",
    "dbm.table.lastUpdate": "Last updated: ",
    "dbm.table.export.lastUpdate": "Document created on: ",
    "dbm.table.export.yearlyAvgTitle": "Yearly average rates Settlements - {year}",
    "dbm.table.export.monthlyOverview": "Monthly overview Settlements - {month} {year}",
    "dbm.table.export.monthlyUltimo": "Monthly average rates - {month} {year}",
    "dbm.table.export.EndofMonthRates": "End of month prices - {month} {year}",
    "dbm.table.loadingData": "Loading data, please wait…",
    "dbm.table.emptyData": "Currently, there is no data available for this period",
    "dbm.currency.base": "Base Currency",
    "dbm.currency.counter": "Counter Currency",
    "dbm.currency.holiday": "Holiday",
    "dbm.fixings.type.first": "1 pm",
    "dbm.fixings.type.second": "6 pm",
    "dbm.currency.ccyPair": "Currency Pair",
    "dbm.currency.valueDate": "Value",
    "dbm.button.valueDateCalendar.toggle": "Toggle Value Date Calendar",
    "dbm.currency.bid": "Bid",
    "dbm.currency.ask": "Offer",
    "dbm.currency.previousBid": "Bid previous Day",
    "dbm.currency.previousAsk": "Offer previous Day",
    "dbm.currency.changeAbsolute": "Change abs.",
    "dbm.currency.gainStatus": " Gain  ",
    "dbm.currency.lossStatus": " Loss  ",
    "dbm.currency.changePercent": "Change %",
    "dbm.currency.daysCount": "Days",
    "dbm.currency.clientBid": "DB Settlement Rate Bid",
    "dbm.currency.clientAsk": "DB Settlement Rate Offer",
    "dbm.currency.traderBid": "Reference Rate Bid",
    "dbm.currency.traderAsk": "Reference Rate Offer",
    "dbm.currency.bidDifference": "Markup/Markdown on Reference Rate",
    "dbm.valueDate": "Value",
    "dbm.dashboard.newsletter.text1": "The new daily newsletter \"Märkte am Morgen\" covering FX and Interest Rates (German language only) is now available to ",
    "dbm.dashboard.newsletter.cta": "subscribe",
    "dbm.dashboard.newsletter.text2": ".",
    "dbm.settlements.tableFooter": "DB Settlement Rates per 1 EUR in Foreign Exchange - {date}, {time}",
    "dbm.settlements.footnoteLeft": `'<h3>'Note'</h3>' The stated prices apply to consumers as well as selected transaction types for non-consumers. Further details can be found in the Terms & Conditions document: '<a href="https://www.deutsche-bank.de/pk/service-und-kontakt/services/konditionen-und-preise.html" target="_blank" rel="noopener noreferrer">'Konditionen und Preise | Deutsche Bank'</a>'
'<br /><br />'The Deutsche Bank foreign exchange rate is based on the reference exchange rate applicable at the time of settlement and includes a bank-specific markup or markdown.'<br/>'`,
    "dbm.settlements.footnoteRight": `
        '<h3>'*The Renminbi'</h3>' Renminbi held, traded and used for payment in the People's Republic of China (mainland China) constitute
        onshore renminbi (ISO code CNY). Outside of mainland China, this constitutes “offshore renminbi – Hong Kong trading” (CNH).
        However, as “CNH” is not registered as a code with the International Organization for Standardization (ISO), it is not used
        in payment services nor for account information.'<br /><br />'
        Renminbi that customers hold, trade or use for payment at Deutsche Bank in Germany constitute offshore Renminbi (CNH) although
        the ISO code CNY must be used in customers’ payment orders, transaction statements and account information.`,
    "dbm.options.chooseCcyPairAndPeriod": "Please choose currency pair and period",
    "dbm.settlement.options.label" : "Settlements options",
    "dbm.settlements.options.saveOptionsButton": "Done",
    "dbm.settlements.options.resetOptionsButton": "Reset Settlements options",
    "dbm.settlements.options.fixingsAt": "Fixings at:",
    "dbm.settlements.options.fixingsAtFootnote": "All rates are displayed with a delay of max. 2 hours.",

    "dbm.home.options.label": "Home options",
    "dbm.home.options.changeCurrencyPairs": "Configure currency pairs",
    "dbm.home.options.saveOptionsButton": "Done",
    "dbm.home.options.resetOptionsButton": "Reset Home options",

    "dbm.spot.options.label": "Spot options",
    "dbm.spot.options.addNewCurrencyPair": "Add single currency pair",
    "dbm.spot.options.addNewCurrencyPairButton": "Add currency pair",
    "dbm.spot.options.addNewGroups": "Add new groups",
    "dbm.spot.options.saveOptionsButton": "Done",
    "dbm.spot.options.resetOptionsButton": "Reset Spot options",
    "dbm.spot.options.groups.majors": "Majors",
    "dbm.spot.options.groups.europe": "Europe",
    "dbm.spot.options.groups.emea": "EMEA",
    "dbm.spot.options.groups.g7": "G7",
    "dbm.spot.options.groups.apac": "APAC",
    "dbm.spot.options.groups.nordic": "Nordic",
    "dbm.spot.options.groups.mena": "MENA",
    "dbm.spot.options.groups.americas": "Americas",
    "dbm.forward.options.label": "Forward options",
    "dbm.forward.options.chooseCurrencyPairs": "Select Currency Pairs",
    "dbm.forward.options.choosePeriod": "Select Periods",
    "dbm.forward.options.saveOptionsButton": "Done",
    "dbm.forward.options.resetOptionsButton": "Reset Forward options",
    "dbm.forward.options.addNewCurrencyPairButton": "Add currency pair",
    "dbm.forward.options.appearanceAskBid": "Appearance Ask / Bid",
    "dbm.forward.options.brokenDate": "Add a value date",
    "dbm.forward.options.appearanceSwapPoints": "Swap Points",
    "dbm.forward.options.appearanceFixings": "Rates",
    "dbm.currencyPair.granularities.1d": "1D",
    "dbm.currencyPair.granularities.1m": "1M",
    "dbm.currencyPair.granularities.3m": "3M",
    "dbm.currencyPair.granularities.6m": "6M",
    "dbm.currencyPair.granularities.ytd": "YTD",
    "dbm.currencyPair.granularities.1y": "1Y",
    "dbm.currencyPair.granularities.5y": "5Y",
    "dbm.currencyPair.granularities.10y": "10Y",
    "dbm.currencyPair.granularities.max": "MAX",
    "dmb.links.contact" : "Contact",
    "dmb.links.api" : "API",
    "dmb.links.taxDisclaimer" : "German Tax Disclaimer",
    "dmb.links.taxDisclaimer.href" : "https://www.deutsche-bank.de/pk/lp/rechtliche-hinweise.html#parsys-accordion-accordionParsys-accordionentry_8612206",
    "dmb.links.imprint" : "Imprint",
    "dmb.links.imprint.href" : "https://www.db.com/company/en/imprint.htm?kid=imprint.inter-en.redirect",
    "dmb.links.termsOfUse" : "Terms of Use",
    "dmb.links.privacyStatement" : "Privacy Statement",
    "dmb.links.deutscheBank" : "Deutsche Bank Group",
    "dmb.links.deutscheBank.href" : "https://www.db.com/company/index.htm"
};

export default en;